"use client"

import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../layout/ThemeProvider';

interface ThemeToggleProps {
  className?: string;
  showText?: boolean;
}

const ThemeToggle = ({ className = '' }: ThemeToggleProps) => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <motion.button
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`${className} fixed top-24 right-6 z-[60] rounded-lg flex items-center justify-center shadow-xl ${
        theme === 'dark'
          ? 'bg-blue-600 text-white hover:bg-blue-700 border border-blue-500'
          : 'bg-blue-500 text-white hover:bg-blue-600 border border-blue-400'
      } transition-colors w-12 h-12`}
      aria-label={theme === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      title={theme === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
    >
      <div className="flex items-center justify-center">
        {/* Ícone do Sol para tema escuro */}
        {theme === 'dark' && (
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        )}
        
        {/* Ícone da Lua para tema claro */}
        {theme === 'light' && (
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            />
          </svg>
        )}
      </div>
    </motion.button>
  );
};

export default ThemeToggle; 